/** Channel-name helpers.
 *
 * The server computes the suggested name (issue detail's
 * suggested_channel_name) and validates the final one against
 * ^[A-Za-z0-9]+(?:-[A-Za-z0-9]+)*$ — this sanitizer maps free-text user edits
 * onto that grammar so the launch request never 400s on the name.
 */

export function sanitizeChannelName(input: string): string {
  return (
    input
      .normalize("NFKD")
      // eslint-disable-next-line no-misleading-character-class -- combining marks
      .replace(/[̀-ͯ]/gu, "")
      .replace(/&/gu, " and ")
      .replace(/[^A-Za-z0-9]+/gu, "-")
      .replace(/-{2,}/gu, "-")
      .replace(/^-+|-+$/gu, "")
      .slice(0, 64)
      .replace(/-+$/u, "")
  );
}
